module.exports = __webpack_public_path__ + "img/visa.ccab0c13.svg";